import React, { useState } from "react";
import styles from "../styles/DevelopmentChargesCalculator.module.css";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const DevelopmentChargesCalculator = () => {
  const [converterType, setConverterType] = useState("Development Charges");
  const [landUseType, setLandUseType] = useState("Residential");
  const [developmentType, setDevelopmentType] = useState("Land Development");
  const [area, setArea] = useState("");
  const [rate, setRate] = useState("");
  const [result, setResult] = useState(0);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);

    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };

    if (pathMap[selected]) {
      navigate(pathMap[selected]);
    }
  };

  const calculateCharges = () => {
    const a = parseFloat(area);
    const r = parseFloat(rate);
    let charges = 0;

    if (!a || !r) {
      alert("Please enter valid Area and Rate");
      return;
    }

    if (landUseType === "Residential" || landUseType === "Institutional") {
      charges = developmentType === "Land Development" ? a * r * 0.005 : a * r * 0.02;
    } else if (landUseType === "Commercial") {
      charges = developmentType === "Land Development" ? a * r * 0.005 * 2 : a * r * 0.02 * 2;
    } else if (landUseType === "Industrial") {
      charges = developmentType === "Land Development" ? a * r * 0.005 * 1.5 : a * r * 0.02 * 1.5;
    }

    setResult(charges.toFixed(2));
  };

  return (
    <div className={styles.developmentChargesCalculator_container}>
      <div className={styles.developmentChargesCalculator_header}>
        <button
          className={styles.developmentChargesCalculator_backButton}
          onClick={handleBack}
        >
          <FaArrowLeft />
        </button>
        <h2 className={styles.developmentChargesCalculator_title}>Conversion Calculator</h2>
      </div>

      <div className={styles.developmentChargesCalculator_dropdownContainer}>
        <select
          value={converterType}
          onChange={handleDropdownChange}
          className={styles.developmentChargesCalculator_mainDropdown}
        >
          <option>Area Convertor</option>
          <option>Built-up Area Calculator</option>
          <option>Development Charges</option>
          <option>Premium for Ancillary FSI</option>
          <option>⁠Premium for Premium FSI</option>
          <option>ULC Premium</option>
        </select>
      </div>

      <div className={styles.developmentChargesCalculator_card}>
        <h3 className={styles.developmentChargesCalculator_sectionTitle}>Development Charges</h3>

        <div className={styles.developmentChargesCalculator_formGroup}>
          <label className={styles.developmentChargesCalculator_label}>Land Use Type:</label>
          <select
            className={styles.developmentChargesCalculator_select}
            value={landUseType}
            onChange={(e) => setLandUseType(e.target.value)}
          >
            <option>Residential</option>
            <option>Commercial</option>
            <option>Industrial</option>
            <option>Institutional</option>
          </select>
        </div>

        <div className={styles.developmentChargesCalculator_formGroup}>
          <label className={styles.developmentChargesCalculator_label}>Development Type:</label>
          <select
            className={styles.developmentChargesCalculator_select}
            value={developmentType}
            onChange={(e) => setDevelopmentType(e.target.value)}
          >
            <option>Land Development</option>
            <option>Building Development</option>
          </select>
        </div>

        <div className={styles.developmentChargesCalculator_formGroup}>
          <label className={styles.developmentChargesCalculator_label}>Area (sq.m):</label>
          <input
            type="number"
            className={styles.developmentChargesCalculator_input}
            value={area}
            onChange={(e) => setArea(e.target.value)}
          />
        </div>

        <div className={styles.developmentChargesCalculator_formGroup}>
          <label className={styles.developmentChargesCalculator_label}>Ready Reckoner Rate (₹/sq.m):</label>
          <input
            type="number"
            className={styles.developmentChargesCalculator_input}
            value={rate}
            onChange={(e) => setRate(e.target.value)}
          />
        </div>

        <button
          className={styles.developmentChargesCalculator_submitButton}
          onClick={calculateCharges}
        >
          Submit
        </button>

        <h3 className={styles.developmentChargesCalculator_resultTitle}>Development Charges</h3>
        <p className={styles.developmentChargesCalculator_resultValue}>₹ {result}</p>
      </div>
    </div>
  );
};

export default DevelopmentChargesCalculator;
